module.exports = __webpack_public_path__ + "img/at.a563282.svg";